import React, { useState, useMemo } from 'react';
import { SlideDown } from 'react-slidedown';

import moment from 'moment';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { Requester } from 'models/travelDetails';

import { Card, AlwaysVisible, Row, Label, Value } from './styles';

interface Props {
  requester: Requester;
}

const Passenger = ({ requester }: Props) => {
  const { t } = useStoreTranslation();

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const formattedBirthDate = useMemo(() => moment.utc(requester.birthDate).format('DD/MM/YYYY'), [requester.birthDate]);

  return (
    <Card>
      <AlwaysVisible onClick={toggleExpand}>
        <AlwaysVisible.Title>{t('travelDetails.passenger.title')}</AlwaysVisible.Title>
        <AlwaysVisible.Arrow className={isExpanded ? 'active' : ''} />
      </AlwaysVisible>
      <SlideDown closed={!isExpanded}>
        <Row>
          <Label>{t('travelDetails.passenger.name')}</Label>
          <Value>{requester.fullName}</Value>
        </Row>
        <Row>
          <Label>{t('travelDetails.passenger.document')}</Label>
          <Value>{requester.documentNumber}</Value>
        </Row>
        <Row>
          <Label>{t('travelDetails.passenger.birthDate')}</Label>
          <Value>{formattedBirthDate}</Value>
        </Row>
        {requester.phoneNumber && (
          <Row>
            <Label>{t('travelDetails.passenger.phoneNumber')}</Label>
            <Value>{requester.phoneNumber}</Value>
          </Row>
        )}
        {requester.email && (
          <Row>
            <Label>{t('travelDetails.passenger.email')}</Label>
            <Value>{requester.email}</Value>
          </Row>
        )}
      </SlideDown>
    </Card>
  );
};

export default Passenger;
